export default __webpack_public_path__ + "static/media/report_dashboard.b97319ed.svg";